const TAP_MOVE_THRESHOLD = 14

function onIntentionalTap(element, handler) {
  if (!element) return

  let pointerStart = null
  let pointerMoved = false

  element.addEventListener(
    "pointerdown",
    (event) => {
      if (event.button !== 0) return
      pointerStart = { x: event.clientX, y: event.clientY }
      pointerMoved = false
    },
    { passive: true }
  )

  element.addEventListener(
    "pointermove",
    (event) => {
      if (!pointerStart) return
      const distance = Math.hypot(event.clientX - pointerStart.x, event.clientY - pointerStart.y)
      if (distance > TAP_MOVE_THRESHOLD) pointerMoved = true
    },
    { passive: true }
  )

  element.addEventListener("pointercancel", () => {
    pointerStart = null
    pointerMoved = false
  })

  element.addEventListener("click", (event) => {
    if (event.pointerType !== "mouse" && pointerMoved) {
      event.preventDefault()
      event.stopPropagation()
    } else {
      handler(event)
    }

    pointerStart = null
    pointerMoved = false
  })
}

function getGallerySlides(gallery) {
  const thumbs = [...gallery.querySelectorAll("[data-portfolio-thumb]")]
  if (thumbs.length) {
    return thumbs.map((thumb) => ({
      src: thumb.dataset.src,
      alt: thumb.dataset.alt || "",
    }))
  }

  const main = gallery.querySelector("[data-portfolio-main]")
  if (!main?.src) return []

  return [{ src: main.src, alt: main.alt || "" }]
}

function showPortfolioSlide(gallery, index) {
  const main = gallery.querySelector("[data-portfolio-main]")
  const thumbs = [...gallery.querySelectorAll("[data-portfolio-thumb]")]
  if (!main || !thumbs.length) return

  const count = thumbs.length
  const normalized = ((index % count) + count) % count
  const thumb = thumbs[normalized]
  const src = thumb.dataset.src
  const alt = thumb.dataset.alt
  if (!src || thumb.getAttribute("aria-selected") === "true") return

  const preload = new Image()
  preload.src = src
  main.src = src
  if (alt) main.alt = alt

  thumbs.forEach((button, i) => {
    button.setAttribute("aria-selected", i === normalized ? "true" : "false")
  })

  gallery.dataset.activeIndex = String(normalized)
}

function initPortfolioLightbox() {
  const dialog = document.querySelector("[data-portfolio-lightbox]")
  const image = dialog?.querySelector("[data-portfolio-lightbox-img]")
  const closeBtn = dialog?.querySelector("[data-portfolio-lightbox-close]")
  const prevBtn = dialog?.querySelector("[data-portfolio-lightbox-prev]")
  const nextBtn = dialog?.querySelector("[data-portfolio-lightbox-next]")

  if (!dialog || !image || !closeBtn || !prevBtn || !nextBtn) return null

  let activeGallery = null
  let lastTrigger = null

  const updateNavVisibility = (slideCount) => {
    const showNav = slideCount > 1
    prevBtn.hidden = !showNav
    nextBtn.hidden = !showNav
  }

  const showLightboxSlide = (index) => {
    if (!activeGallery) return

    const slides = getGallerySlides(activeGallery)
    if (!slides.length) return

    const normalized = ((index % slides.length) + slides.length) % slides.length
    const slide = slides[normalized]
    image.src = slide.src
    image.alt = slide.alt

    activeGallery.dataset.activeIndex = String(normalized)
    if (activeGallery.querySelector("[data-portfolio-thumb]")) {
      showPortfolioSlide(activeGallery, normalized)
    }

    updateNavVisibility(slides.length)
  }

  const open = (gallery, trigger) => {
    activeGallery = gallery
    lastTrigger = trigger
    const index = Number(gallery.dataset.activeIndex ?? 0)
    dialog.showModal()
    showLightboxSlide(index)
  }

  const close = () => {
    dialog.close()
    activeGallery = null
    lastTrigger?.focus()
    lastTrigger = null
  }

  closeBtn.addEventListener("click", close)

  dialog.addEventListener("click", (event) => {
    if (event.target === dialog) close()
  })

  dialog.addEventListener("close", () => {
    image.removeAttribute("src")
    image.alt = ""
    prevBtn.hidden = true
    nextBtn.hidden = true
    activeGallery = null
  })

  dialog.addEventListener("keydown", (event) => {
    if (event.key === "ArrowLeft") {
      event.preventDefault()
      const current = Number(activeGallery?.dataset.activeIndex ?? 0)
      showLightboxSlide(current - 1)
    }

    if (event.key === "ArrowRight") {
      event.preventDefault()
      const current = Number(activeGallery?.dataset.activeIndex ?? 0)
      showLightboxSlide(current + 1)
    }
  })

  onIntentionalTap(prevBtn, () => {
    const current = Number(activeGallery?.dataset.activeIndex ?? 0)
    showLightboxSlide(current - 1)
  })

  onIntentionalTap(nextBtn, () => {
    const current = Number(activeGallery?.dataset.activeIndex ?? 0)
    showLightboxSlide(current + 1)
  })

  return { open }
}

function initPortfolioGalleries() {
  const lightbox = initPortfolioLightbox()

  document.querySelectorAll("[data-portfolio-gallery]").forEach((gallery) => {
    const thumbs = gallery.querySelectorAll("[data-portfolio-thumb]")
    const expand = gallery.querySelector("[data-portfolio-expand]")

    gallery.dataset.activeIndex = "0"

    thumbs.forEach((thumb, index) => {
      onIntentionalTap(thumb, () => showPortfolioSlide(gallery, index))
    })

    const prev = gallery.querySelector("[data-portfolio-prev]")
    const next = gallery.querySelector("[data-portfolio-next]")

    onIntentionalTap(prev, () => {
      const current = Number(gallery.dataset.activeIndex ?? 0)
      showPortfolioSlide(gallery, current - 1)
    })

    onIntentionalTap(next, () => {
      const current = Number(gallery.dataset.activeIndex ?? 0)
      showPortfolioSlide(gallery, current + 1)
    })

    onIntentionalTap(expand, () => {
      lightbox?.open(gallery, expand)
    })
  })
}

document.addEventListener("DOMContentLoaded", initPortfolioGalleries)